import { BigNumberish, formatEther } from 'ethers'

// formats a BigNumber to a number with a given number of decimals
export const roundedBigNumber = (num: BigNumberish | undefined, decimals = 4): number => {
  if (!num) {
    return 0
  }
  const value = formatEther(num) as never
  return Math.round(value * 10 ** decimals) / 10 ** decimals
}

export const displayBN = (num: bigint, fractionDigits = 2): string => {
  return formatNumber(Number(formatEther(num)).toFixed(fractionDigits))
}

export const formatNumber = (
  value: number | string,
  fractionDigits = 2,
  roundingMode?: 'halfCeil',
): string => {
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
    roundingMode: roundingMode,
  }).format(Number(value))
}

// Compact, single-line formatting for stat tiles: 29,306 -> "29.3K", 5,000,000 -> "5M".
export const compactNumber = (value: number | string, maxFractionDigits = 1): string => {
  const n = Number(value)
  if (!Number.isFinite(n)) return '0'
  if (n > 0 && n < 1000) {
    return new Intl.NumberFormat('en-US', { maximumFractionDigits: 2 }).format(n)
  }
  return new Intl.NumberFormat('en-US', {
    notation: 'compact',
    maximumFractionDigits: maxFractionDigits,
  }).format(n)
}

export const USDValue = (
  value: bigint | number | string,
  coingeckoPrices: { [key: string]: { usd: number } } | null,
  tokenValue: string,
) => {
  const formatValue = Number(value)

  let price

  if (!coingeckoPrices) {
    return 'Loading...'
  }

  switch (tokenValue) {
    case 'ggp':
      price = coingeckoPrices['gogopool'].usd
      break
    case 'avax':
      price = coingeckoPrices['avalanche-2'].usd
      break
    default:
      return 'Loading...'
  }

  return formatNumber(formatValue * price, 0)
}
